import React from "react";

import {
    Box,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Switch,
    TextField,
} from "@mui/material";

import { Source } from "Constant/source";

import MouseOverPopover from "components/MouseOverPopover";
import TagsInput from "components/TagsInput";

import { DEFAULT_HOST } from "../../SourceCreation.constants";
import { createSubDomain } from "../../SourceCreation.helpers";

const ValidationError = ({ language }) => (
    <FormHelperText>
        {language?.source_modal?.validation_error ?? "Validation Error"}
    </FormHelperText>
);

/** Shared fields for `js` and `redirect` sources: aliases + optional custom host. */
const WebSourceFields = ({ sourceType, language, form }) => {
    const {
        form: values,
        formErrors,
        setField,
        setSubdomain,
        aliases,
        setAliases,
        useGenericDomain,
        setUseGenericDomain,
    } = form;

    const aliasLabel =
        sourceType === Source.redirect
            ? (language?.tracker_wizard?.domains ?? "Add Redirect Address")
            : (language?.tracker_wizard?.add_allowed_domains ??
              "Add Allowed Domain(s)");

    return (
        <>
            <FormControl fullWidth>
                <TagsInput
                    tags={aliases}
                    setTags={setAliases}
                    label={aliasLabel}
                />
            </FormControl>
            <Box sx={{ my: 3 }}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={useGenericDomain}
                            onChange={(event) =>
                                setUseGenericDomain(event.target.checked)
                            }
                        />
                    }
                    label={
                        language?.tracker_wizard?.use_generic_domain ??
                        "Use generic domain"
                    }
                />
            </Box>
            {!useGenericDomain && (
                <Grid container spacing={2}>
                    <Grid size={5}>
                        <FormControl
                            fullWidth
                            sx={{ mb: 3 }}
                            error={formErrors.host === null}
                        >
                            <TextField
                                id="host"
                                label={
                                    language?.tracker_wizard
                                        ?.signal_host_name ?? "Signal Host Name"
                                }
                                variant="outlined"
                                onChange={(event) =>
                                    setField("host", event.target.value)
                                }
                                error={formErrors.host === null}
                                defaultValue={DEFAULT_HOST}
                            />
                            {formErrors.host && (
                                <ValidationError language={language} />
                            )}
                        </FormControl>
                    </Grid>
                    <Grid size={7}>
                        <FormControl
                            fullWidth
                            className="mouse-over-popover-area"
                            sx={{ mb: 3 }}
                            error={formErrors.subdomain === null}
                        >
                            <TextField
                                id="subdomain"
                                label="Sub Domain"
                                variant="outlined"
                                onChange={(event) =>
                                    setSubdomain(event.target.value)
                                }
                                placeholder="example.com"
                                error={formErrors.subdomain === null}
                                defaultValue={createSubDomain(values?.domain)}
                            />
                            {formErrors.subdomain && (
                                <ValidationError language={language} />
                            )}
                            <MouseOverPopover text="Host name and subdomain information<br/>ie. cpl.websitename.com" />
                        </FormControl>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default WebSourceFields;
